var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllRequestCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 385,
    viewBox: "0 0 426 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.011 21.5859H35.0512C28.3341 21.5859 22.8888 24.4296 22.8888 27.9374V322.821C22.8888 326.329 28.3341 329.172 35.0512 329.172H344.011C350.728 329.172 356.173 326.329 356.173 322.821V27.9374C356.173 24.4296 350.728 21.5859 344.011 21.5859Z",
    fill: "#45A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.684 10.1445H20.7251C14.0079 10.1445 8.56262 12.9882 8.56262 16.496V311.379C8.56262 314.887 14.0079 317.731 20.7251 317.731H329.684C336.402 317.731 341.847 314.887 341.847 311.379V16.496C341.847 12.9882 336.402 10.1445 329.684 10.1445Z",
    fill: "#45A4AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.8 308.818V16.0788C338.8 12.8769 337.103 10.2812 335.009 10.2812L16.0027 10.2813C13.9089 10.2813 12.2116 12.8769 12.2116 16.0788V308.818C12.2116 312.02 13.9089 314.615 16.0027 314.615L335.009 314.615C337.103 314.615 338.8 312.02 338.8 308.818Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338.546 10.2812H12.2307C10.2049 10.2812 8.56262 11.977 8.56262 14.0688V29.3765C8.56262 31.4683 10.2049 33.164 12.2307 33.164H338.546C340.572 33.164 342.215 31.4683 342.215 29.3765V14.0688C342.215 11.977 340.572 10.2812 338.546 10.2812Z",
    fill: "#45A4AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M308.353 21.7242C308.353 24.1935 306.438 26.1906 304.075 26.1906C301.713 26.1906 299.798 24.1935 299.798 21.7242C299.798 19.2549 301.713 17.2578 304.075 17.2578C306.438 17.2578 308.353 19.2549 308.353 21.7242Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M321.73 21.7242C321.73 24.1935 319.815 26.1906 317.452 26.1906C315.089 26.1906 313.174 24.1935 313.174 21.7242C313.174 19.2549 315.089 17.2578 317.452 17.2578C319.815 17.2578 321.73 19.2549 321.73 21.7242Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M335.106 21.7242C335.106 24.1935 333.191 26.1906 330.828 26.1906C328.465 26.1906 326.55 24.1935 326.55 21.7242C326.55 19.2549 328.465 17.2578 330.828 17.2578C333.191 17.2578 335.106 19.2549 335.106 21.7242Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.3395 15.9844H16.3448V27.4651H27.3395V15.9844Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.968 57.5195H85.5083V100.522H302.968V57.5195Z",
    fill: "#0D8390"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M302.968 57.5195H85.5083V100.522H302.968V57.5195Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.801 70.0234H99.4388V87.9708H116.801V70.0234Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.229 79.0506L106.476 83.3654L112.989 74.6523",
    stroke: "#0D8390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M271.005 137H53.5459V180.003H271.005V137Z",
    fill: "#0D8390"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M271.005 137H53.5459V180.003H271.005V137Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8385 149.531H67.4764V167.479H84.8385V149.531Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M304.072 220.215H86.6123V263.218H304.072V220.215Z",
    fill: "#0D8390"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M304.072 220.215H86.6123V263.218H304.072V220.215Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.905 232.746H100.543V250.693H117.905V232.746Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.354 241.752L107.58 246.067L114.113 237.375",
    stroke: "#0D8390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M387.137 354.789C408.282 338.401 412.256 308.074 396.014 287.05C379.772 266.027 349.464 262.269 328.319 278.656C307.175 295.044 303.2 325.371 319.442 346.394C335.684 367.418 365.992 371.176 387.137 354.789Z",
    fill: "#0A525A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.599 298.155L373.026 314.776C372.044 315.766 371.755 316.053 371.473 316.348C371.208 316.625 370.95 316.908 370.126 317.79C369.391 318.576 369.131 318.848 368.875 319.124C368.54 319.485 368.213 319.855 366.832 321.402L355.356 333.709L356.342 334.578C355.949 334.233 355.625 333.947 355.356 333.709L354.954 334.14L354.013 335.223C352.215 337.021 352.125 337.256 352.125 337.256L350.207 339.202L349.191 340.306C348.157 339.378 347.959 339.188 347.755 339.007C347.562 338.834 347.362 338.669 346.437 337.887C345.615 337.193 345.331 336.947 345.042 336.705C344.664 336.389 344.279 336.081 342.664 334.779L326.291 320.981C324.39 319.375 324.137 316.501 325.73 314.612C327.323 312.724 330.198 312.491 332.098 314.097L348.453 327.913L360.733 314.776L361.123 314.358C363.289 311.885 363.345 311.807 363.415 311.744C363.461 311.702 363.512 311.666 364.19 310.941C364.989 310.087 364.989 310.086 365.113 309.968C365.252 309.836 365.546 309.554 367.318 307.731L366.387 308.687L382.015 292.009C383.714 290.191 386.598 290.083 388.404 291.769C390.21 293.455 390.298 296.337 388.599 298.155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllRequestCompletedIcon);
export default __webpack_public_path__ + "static/media/allRequestCompletedIcon.6e4e9ed179624f3c0de724822f99b852.svg";
export { ForwardRef as ReactComponent };